export default function getOverallMax(...arrays) {
    // 扁平化所有非空子数组的最大值
    const maxValues = arrays
        .filter(arr => Array.isArray(arr) && arr.length > 0) // 只保留非空数组
        .map(arr => arr.reduce((a, b) => Math.max(a, b), -Infinity)); // 使用 reduce 更安全

    // 如果没有有效的最大值（所有数组为空），返回 null
    if (maxValues.length === 0) return null;

    // 返回所有最大值中的最大值
    return maxValues.reduce((a, b) => Math.max(a, b), -Infinity);
}


export function niceInterval(maxValue, steps = 5) {
    if (!maxValue) return 1;

    const roughInterval = maxValue / steps; // 初步间隔
    const magnitude = Math.pow(10, Math.floor(Math.log10(roughInterval))); // 位数
    const residual = roughInterval / magnitude;

    let niceResidual;

    if (residual <= 1) {
        niceResidual = 1;
    } else if (residual <= 2) {
        niceResidual = 2;
    } else if (residual <= 5) {
        niceResidual = 5;
    } else {
        niceResidual = 10;
    }

    return niceResidual * magnitude;
}


//修改日期
export function convertDateList(dateList) {
    const monthMap = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    };

    return dateList.map(dateStr => {
        const match = dateStr.match(/(\d{2})月(\d{2})日/);
        if (match) {
            const [, month, day] = match;
            const monthEn = monthMap[month] || month;
            return `${monthEn} ${parseInt(day)}`;  // 去掉前导0
        }
        return dateStr; // 如果格式不匹配，原样返回
    });
}


export function convertWeekDateList(dateList) {
    const monthMap = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    };

    return dateList.map(item => {
        if (item === "本周") return "This Week";

        const match = item.match(/^(\d{2})\.(\d{2})-(\d{2})\.(\d{2})$/);
        if (match) {
            const [, startMonth, startDay, endMonth, endDay] = match;
            const startMonthEn = monthMap[startMonth] || startMonth;
            const endMonthEn = monthMap[endMonth] || endMonth;

            const startDayClean = parseInt(startDay);
            const endDayClean = parseInt(endDay);

            return `${startMonthEn} ${startDayClean} - ${endMonthEn} ${endDayClean}`;
        }

        return item; // 如果格式不匹配，原样返回
    });
}


export function convertMonthList(dateList) {
    const monthMap = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    };

    return dateList.map(item => {
        const match = item.match(/^(\d{2})月$/);
        if (match) {
            const month = match[1];
            return monthMap[month] || item;
        }
        return item; // 如果格式不匹配，原样返回
    });
}


//将年月日 转换为 国际标准形式
/**
 * 将日期字符串转换为国际标准 ISO 8601 格式
 * 支持:
 *  - YYYY年MM月DD日 [HH:mm[:ss]]
 *  - YYYY-MM-DD [HH:mm[:ss]]
 *  - YYYY/MM/DD [HH:mm[:ss]]
 *
 * @param {string} dateStr
 * @returns {string} ISO 格式
 */
export function toISODateTime(dateStr) {
    let year, month, day, hour = '00', minute = '00', second = '00';
    let hasTime = false;

    // 匹配带时间的格式（年/月/日 或 - 或 /）
    const match = dateStr.match(
        /^(\d{4})[年/-](\d{1,2})[月/-](\d{1,2})日?(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/
    );

    if (!match) {
        throw new Error("日期格式不正确，应为 YYYY年MM月DD日 或 YYYY-MM-DD 或 YYYY/MM/DD，可选时间 HH:mm[:ss]");
    }

    year = match[1];
    month = match[2].padStart(2, '0');
    day = match[3].padStart(2, '0');

    if (match[4] !== undefined) {
        hasTime = true;
        hour = match[4].padStart(2, '0');
        minute = match[5].padStart(2, '0');
        second = (match[6] || '00').padStart(2, '0');
    }

    return hasTime
        ? `${year}-${month}-${day}T${hour}:${minute}:${second}Z`
        : `${year}-${month}-${day}`;
}

